import axios from 'axios';
import store from '@/store'

const baseURL = process.env.VUE_APP_ENGINE_URL;
const tenantId = process.env.VUE_APP_TENANT;

const apiUsername = process.env.VUE_APP_ENGINE_API_USER;
const apiPassword = process.env.VUE_APP_ENGINE_API_PASS;
const apiToken = Buffer.from(`${apiUsername}:${apiPassword}`, 'utf8').toString('base64');

const state = {
  allTenants: [],
  storageDetails: [],
  savedStorageDetails: '',
  serverDetails: [],
  savedServerDetails: '',
  ssoDetails: [],
  savedSsoDetails: '',
  samlMetadata: '',
  availableLdapUsers: [],
  availableLdapGroups: [],
  availableLdapTree: [],
  ldapStoreStatus: false,
  ldapGetStatus: false,
  ldapSelectStatus: false,
  ldapSyncUserData: [],
  ldapSyncGroupData: [],
  ldapSelectedData: [],
  ldapGroupUserAdded: {},
  ldapUserAdded: {},
  ldapGroupUsersAdded: '',
  savedTemplate: '',
  templateId: '',
  templateName: '',
  templateKey: '',
  templateType: '',
  templateAction: '',
  templateData: '',
  lastTab: 0,
  allDocTemplates: [],
  allEmailTemplates: [],
  deletedTemplate: '',
  allExtDbs: [],
  dbConnAdded: '',
  dbConnEdited: '',
  dbConnDeleted: '',
  checkEngine: false,
  allHqConns: [],
  tenantInfo: [],
  hqConnAdded: '',
  hqConnEdited: '',
  hqConnDeleted: '',
  tenantsAdded: false,
  remoteTenants: [],
  allApis: [],
  apiAdded: false,
  apiUpdated: false,
  apiDeleted: false,
  operationLog: [],
  operationLogError: '',
  operationLogUpdated: '',
  errorLog: [],
  errorLogError: '',
  promoteTemplateData: [],
  promoteTemplateRes: [],
  licenseStartDate: '',
  licenseExpiryDate: '',
  licenseKeyUpdated: '',
  enableProcessUndeploy: false,
  enableProcessDeletion: false,
  enablePentestMode: false,
  supportRequest: false,
  supportEmail: '',
  resetKeyCreated: false,
  resetKeyRemoved: false,
  resetUid: ''
};

const getters = {
  allTenants: (state) => state.allTenants,
  storageDetails: (state) => state.storageDetails,
  serverDetails: (state) => state.serverDetails,
  ssoDetails: (state) => state.ssoDetails,
  samlMetadata: (state) => state.samlMetadata,
  availableLdapUsers: (state) => state.availableLdapUsers,
  availableLdapGroups: (state) => state.availableLdapGroups,
  availableLdapTree: (state) => state.availableLdapTree,
  ldapStoreStatus: (state) => state.ldapStoreStatus,
  ldapGetStatus: (state) => state.ldapGetStatus,
  ldapSelectStatus: (state) => state.ldapSelectStatus,
  ldapSyncUserData: (state) => state.ldapSyncUserData,
  ldapSyncGroupData: (state) => state.ldapSyncGroupData,
  ldapSelectedData: (state) => state.ldapSelectedData,
  ldapGroupUserAdded: (state) => state.ldapGroupUserAdded,
  ldapUserAdded: (state) => state.ldapUserAdded,
  templateId: (state) => state.templateId,
  templateName: (state) => state.templateName,
  templateKey: (state) => state.templateKey,
  templateType: (state) => state.templateType,
  templateAction: (state) => state.templateAction,
  templateData: (state) => state.templateData,
  lastTab: (state) => state.lastTab,
  allDocTemplates: (state) => state.allDocTemplates,
  allEmailTemplates: (state) => state.allEmailTemplates,
  allExtDbs: (state) => state.allExtDbs,
  dbConnAdded: (state) => state.dbConnAdded,
  dbConnEdited: (state) => state.dbConnEdited,
  checkEngine: (state) => state.checkEngine,
  tenantsAdded: (state) => state.tenantsAdded,
  allHqConns: (state) => state.allHqConns,
  tenantInfo: (state) => state.tenantInfo,
  remoteTenants: (state) => state.remoteTenants,
  allApis: (state) => state.allApis,
  apiAdded: (state) => state.apiAdded,
  apiUpdated: (state) => state.apiUpdated,
  apiDeleted: (state) => state.apiDeleted,
  operationLog: (state) => state.operationLog,
  operationLogError: (state) => state.operationLogError,
  errorLog: (state) => state.errorLog,
  errorLogError: (state) => state.errorLogError,
  promoteTemplateData: (state) => state.promoteTemplateData,
  promoteTemplateRes: (state) => state.promoteTemplateRes,
  licenseStartDate: (state) => state.licenseStartDate,
  licenseExpiryDate: (state) => state.licenseExpiryDate,
  enableProcessUndeploy: (state) => state.enableProcessUndeploy,
  enableProcessDeletion: (state) => state.enableProcessDeletion,
  enablePentestMode: (state) => state.enablePentestMode,
  supportRequest: (state) => state.supportRequest,
  supportEmail: (state) => state.supportEmail,
  resetKeyCreated: (state) => state.resetKeyCreated,
  resetKeyRemoved: (state) => state.resetKeyRemoved,
  resetUid: (state) => state.resetUid
};

const actions = {
  getAllTenants({commit}) {
    return axios.get(baseURL + '/tenant', {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      commit('ALL_TENANTS', result.data);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getLicense({commit}) {
    let data = {
      'variables': {
        'requestType': { 'value': 'get', 'type': 'String' }
      },
      'withVariablesInReturn': true
    }
    return axios.post(baseURL + '/process-definition/key/licenseController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( result => {      
      commit('LICENSE_START_DATE', result.data.variables.startDate.value);
      commit('LICENSE_EXPIRY_DATE', result.data.variables.expiryDate.value);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  setLicense({commit}, key) {
    let data = {
      'variables': {
        'requestType': { 'value': 'set', 'type': 'String' },
        'licenseKey': { 'value': key, 'type': 'String' }
      }
    }
    return axios.post(baseURL + '/process-definition/key/licenseController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {      
      commit('LICENSE_KEY_UPDATED', 'success');
      this.dispatch('getLicense');
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  processSettings({commit}, payload) {
    let data = {
      'variables': {
        'pType': { 'value': 'settings', 'type': 'String' },
        'action': { 'value': payload.action, 'type': 'String' }
      },
      'withVariablesInReturn': true
    }

    if(payload.action == 'deploy') {
      data.variables['enableUndeploy'] = { 'value': payload.enableUndeploy, 'type': 'String' };
    }

    if(payload.action == 'deletion') {
      data.variables['enableDeletion'] = { 'value': payload.enableDeletion, 'type': 'String' };
    }

    if(payload.action == 'pentest') {
      data.variables['enablePentest'] = { 'value': payload.enablePentest, 'type': 'String' };
    }

    return axios.post(baseURL + '/process-definition/key/processController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
      if(payload.action == 'getAll') {
        commit('ENABLE_PROCESS_UNDEPLOY', result.data.variables.enableUndeploy.value);
        commit('ENABLE_PROCESS_DELETION', result.data.variables.enableDeletion.value);
        commit('ENABLE_PENTEST_MODE', result.data.variables.enablePentest.value);
      }
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  saveStorageDetails({commit}, payload) {
    let data = {
      'variables': {
        'storage': { 'value': 'settings', 'type': 'String' },
        'requestType': { 'value': 'save', 'type': 'String' },
        'localEnabled': { 'value': payload.localEnabled, 'type': 'String' },
        'officeEnabled': { 'value': payload.officeEnabled, 'type': 'String' },
        'officeTenantId': { 'value': payload.officeTenantId, 'type': 'String' },
        'officeClientId': { 'value': payload.officeClientId, 'type': 'String' },
        'officeClientSecret': { 'value': payload.officeClientSecret, 'type': 'String' },
        'officeGroupName': { 'value': payload.officeGroupName, 'type': 'String' },
        'officeUploadPath': { 'value': payload.officeUploadPath, 'type': 'String' }
      }
    }
    return axios.post(baseURL + '/process-definition/key/fileController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {      
      commit('SAVED_STORAGE_DETAILS', 'success');
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getStorageDetails({commit}) {
    let data = {
      'variables': {
        'storage': { 'value': 'settings', 'type': 'String' },
        'requestType': { 'value': 'get', 'type': 'String' }
      },
      'withVariablesInReturn': true
    }
    return axios.post(baseURL + '/process-definition/key/fileController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      let data = JSON.parse(result.data.variables.storageSettings.value);
      let storageSettings = [];

      for(let i = 0; i < data.length; i++) {
        const storageKeys = Object.keys(data[i]);

        storageKeys.forEach((skey) => {
          if(skey == 'officeEnabled' || skey == 'localEnabled') {
            if(data[i][skey] == 'true') {
              data[i][skey] = true;
            }else {
              data[i][skey] = false;
            }
          }
          storageSettings[skey] = data[i][skey];
        });
      }
      commit('STORAGE_DETAILS', storageSettings);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getExternalStorageDetails({commit}) {
    let data = {
      'variables': {
        'storage': { 'value': 'settings', 'type': 'String' },
        'requestType': { 'value': 'get', 'type': 'String' }
      },
      'withVariablesInReturn': true
    }
    return axios.post(baseURL + '/process-definition/key/fileController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( result => {      
      let data = JSON.parse(result.data.variables.storageSettings.value);
      let storageSettings = [];

      for(let i = 0; i < data.length; i++) {
        const storageKeys = Object.keys(data[i]);

        storageKeys.forEach((skey) => {
          if(skey == 'officeEnabled' || skey == 'localEnabled') {
            if(data[i][skey] == 'true') {
              data[i][skey] = true;
            }else {
              data[i][skey] = false;
            }
          }
          storageSettings[skey] = data[i][skey];
        });
      }
      commit('STORAGE_DETAILS', storageSettings);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  saveServerDetails({commit}, payload) {
    let data = {};

    if(payload.emailType == 'msg') {
      data = {
        'variables': {
          'email': { 'value': 'settings', 'type': 'String' },
          'requestType': { 'value': 'save', 'type': 'String' },
          'emailGraphClientId': { 'value': payload.emailGraphClientId, 'type': 'String' },
          'emailGraphClientSecret': { 'value': payload.emailGraphClientSecret, 'type': 'String' },
          'emailGraphEmailId': { 'value': payload.emailGraphEmailId, 'type': 'String' },
          'emailGraphTenantId': { 'value': payload.emailGraphTenantId, 'type': 'String' },
          'emailType': { 'value': payload.emailType, 'type': 'String' }
        }
      }
    }else {
      data = {
        'variables': {
          'email': { 'value': 'settings', 'type': 'String' },
          'requestType': { 'value': 'save', 'type': 'String' },
          'emailHost': { 'value': payload.emailHost, 'type': 'String' },
          'emailPort': { 'value': payload.emailPort, 'type': 'String' },
          'emailTls': { 'value': payload.emailTls, 'type': 'String' },
          'emailSender': { 'value': payload.emailSender, 'type': 'String' },
          'emailUsername': { 'value': payload.emailUsername, 'type': 'String' },
          'emailPassword': { 'value': payload.emailPassword, 'type': 'String' },
          'emailType': { 'value': payload.emailType, 'type': 'String' }
        }
      }
    }
    return axios.post(baseURL + '/process-definition/key/emailController/tenant-id/harlequin/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {      
      commit('SAVED_SERVER_DETAILS', 'success');
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getServerDetails({commit}) {
    let data = {
      'variables': {
        'email': { 'value': 'settings', 'type': 'String' },
        'requestType': { 'value': 'get', 'type': 'String' }
      },
      'withVariablesInReturn': true
    }
    return axios.post(baseURL + '/process-definition/key/emailController/tenant-id/harlequin/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      let data = JSON.parse(result.data.variables.serverSettings.value);
      let serverSettings = [];

      for(let i = 0; i < data.length; i++) {
        const storageKeys = Object.keys(data[i]);

        storageKeys.forEach((skey) => {
          if(skey == 'emailTls') {
            if(data[i][skey] == 'true') {
              data[i][skey] = true;
            }else {
              data[i][skey] = false;
            }
          }
          serverSettings[skey] = data[i][skey];
        });
      }
      commit('SERVER_DETAILS', serverSettings);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  saveSsoDetails({commit}, payload) {
    let spUrl = window.location.href;
    spUrl = spUrl.replace('admin', '');

    let data = {
      'variables': {
        'sso': { 'value': 'settings', 'type': 'String' },
        'requestType': { 'value': 'save', 'type': 'String' },
        'msalEnabled': { 'value': payload.msalEnabled, 'type': 'String' },
        'msalClientId': { 'value': payload.msalClientId, 'type': 'String' },
        'msalAuthority': { 'value': payload.msalAuthority, 'type': 'String' },
        'msalRedirectUri': { 'value': payload.msalRedirectUri, 'type': 'String' },
        'msalAuthState': { 'value': payload.msalAuthState, 'type': 'String' },
        'samlEnabled': { 'value': payload.samlEnabled, 'type': 'String' },
        'samlIpId': { 'value': payload.samlIpId, 'type': 'String' },
        'samlIpSls': { 'value': payload.samlIpSls, 'type': 'String' },
        'samlIpSos': { 'value': payload.samlIpSos, 'type': 'String' },
        'samlSpAcs': { 'value': payload.samlSpAcs, 'type': 'String' },
        'samlSpId': { 'value': payload.samlSpId, 'type': 'String' },
        'samlSpSls': { 'value': payload.samlSpSls, 'type': 'String' },
        'samlIpEmailAttr': { 'value': payload.samlIpEmailAttr, 'type': 'String' },
        'samlIpFirstAttr': { 'value': payload.samlIpFirstAttr, 'type': 'String' },
        'samlIpLastAttr': { 'value': payload.samlIpLastAttr, 'type': 'String' },
        'samlIpCfr': { 'value': payload.samlIpCfr, 'type': 'String' },
        'samlSigAlg': { 'value': payload.samlSigAlg, 'type': 'String' },
        'samlIpCert': { 'value': payload.samlIpCert, 'type': 'String' },
        'samlBaseUrl': { 'value': spUrl, 'type': 'String' },
        'ldapEnabled': { 'value': payload.ldapEnabled, 'type': 'String' },
        'ldapLoginEnabled': { 'value': payload.ldapLoginEnabled, 'type': 'String' },
        'ldapServer': { 'value': payload.ldapServer, 'type': 'String' },
        'ldapPort': { 'value': payload.ldapPort, 'type': 'String' },
        'ldapUsername': { 'value': payload.ldapUsername, 'type': 'String' },
        'ldapPassword': { 'value': payload.ldapPassword, 'type': 'String' },
        'ldapBaseDn': { 'value': payload.ldapBaseDn, 'type': 'String' },
        'ldapIdentifier': { 'value': payload.ldapIdentifier, 'type': 'String' },
        'ldapUsersCn': { 'value': payload.ldapUsersCn, 'type': 'String' },
        'ldapGroupsCn': { 'value': payload.ldapGroupsCn, 'type': 'String' },
        'ldapTls': { 'value': payload.ldapTls, 'type': 'String' }
      }
    }
    return axios.post(baseURL + '/process-definition/key/ssoController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {      
      commit('SAVED_SSO_DETAILS', 'success');
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  saveAutoSyncDetails({commit}, payload) {
    let data = {
      'variables': {
        'requestType': { 'value': 'saveSync', 'type': 'String' },
        'ldapAutoSync': { 'value': payload.ldapAutoSync, 'type': 'String' },
        'ldapAutoSyncTime': { 'value': payload.ldapAutoSyncTime, 'type': 'String' }
      }
    }
    return axios.post(baseURL + '/process-definition/key/ldapController/tenant-id/' + tenantId + '/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {      
      commit('SAVED_SSO_DETAILS', 'success');
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getSsoDetails({commit}) {
    let data = {
      'variables': {
        'sso': { 'value': 'settings', 'type': 'String' },
        'requestType': { 'value': 'get', 'type': 'String' }
      },
      'withVariablesInReturn': true
    }
    return axios.post(baseURL + '/process-definition/key/ssoController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( result => {      
      let data = JSON.parse(result.data.variables.ssoSettings.value);
      let ssoSettings = [];

      for(let i = 0; i < data.length; i++) {
        const ssoKeys = Object.keys(data[i]);

        ssoKeys.forEach((skey) => {
          if(skey == 'msalEnabled' || skey == 'samlEnabled' || skey == 'msalAuthState' || skey == 'ldapEnabled' || skey == 'ldapLoginEnabled' || skey == 'ldapTls' || skey == 'ldapAutoSync') {
            if(data[i][skey] == 'true') {
              data[i][skey] = true;
            }else {
              data[i][skey] = false;
            }
          }
          ssoSettings[skey] = data[i][skey];
        });
      }

      let spUrl = window.location.href;
      spUrl = spUrl.replace('admin', '');

      ssoSettings['samlSpId'] = spUrl + 'saml/metadata.jsp';
      ssoSettings['samlSpAcs'] = spUrl + 'saml/acs.jsp';
      ssoSettings['samlSpSls'] = spUrl + 'saml/sls.jsp';
      
      commit('SSO_DETAILS', ssoSettings);
    }).catch( () => {
      // throw new Error(`API ${error}`);
    });
  },
  getSamlMetadata({commit}) {
    let data = {
      'variables': {
        'sso': { 'value': 'xml', 'type': 'String' },
        'requestType': { 'value': 'metadata', 'type': 'String' }
      },
      'withVariablesInReturn': true
    }
    return axios.post(baseURL + '/process-definition/key/ssoController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( result => {      
      let data = JSON.parse(result.data.variables.samlMetadata.value);      
      commit('SAML_METADATA', data);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  ldapSelect({commit}) {
    let data = {
      'variables': {
        'requestType': { 'value': 'select', 'type': 'String' }
      },
      'withVariablesInReturn': true
    }
    return axios.post(baseURL + '/process-definition/key/ldapController/tenant-id/' + tenantId + '/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( async result => {      
      let selectStatus = result.data.variables.selectStatus.value;

      if(selectStatus) {
        let userData = JSON.parse(result.data.variables.allUsers.value);
        let groupData = JSON.parse(result.data.variables.allGroups.value);
      
        await this.dispatch('getLdapItems').then( () => {
          commit('LDAP_SELECT_STATUS', selectStatus);
          commit('LDAP_USER_DATA', userData);
          commit('LDAP_GROUP_DATA', groupData);

          // Testing treeview
          let treeData = [];
          let itemId = 1;

          for(let i = 0; i < groupData.length; i++) {
            let ouList = [];
            let dn = groupData[i].distinguishedName;
            let dnParts = dn.split(',');
            let previousOu = '';
            let currentItem = {};
            
            // Reverse the array
            dnParts.reverse();
            // Loop through each dn part to find OUs
            for(let j = 0; j < dnParts.length; j++) {
              let dnType = dnParts[j].substring(0,2);
              
              if(dnType == 'OU') {
                let ouData = dnParts[j].split("=");
                ouList.push(ouData[1]);
              }
            }

            for(let k = 0; k < ouList.length; k++) {
              if(treeData.length > 0) {

                // Check top level
                let itemExists = false;
                for(let l = 0; l < treeData.length; l++) {
                  if(ouList[k] == treeData[l].name) {
                    itemExists = true;
                  }
                }

                // Check children
                const findItemNested = (arr, itemName, nestingKey) => (
                  arr.reduce((a, item) => {
                    if (a) return a;
                    if (item.name === itemName) return item;
                    if (item[nestingKey]) return findItemNested(item[nestingKey], itemName, nestingKey)
                  }, null)
                );

                if(!itemExists) {
                  let itemFound = findItemNested(treeData, ouList[k], "children");
                  
                  // Didn't find the OU, so add it
                  if(!itemFound) {
                    let prevItem = findItemNested(treeData, previousOu, "children");
                    prevItem.children.push({ id: itemId, name: ouList[k], children: [] });
                    
                    itemId++;
                  }
                  currentItem = findItemNested(treeData, ouList[k], "children");
                }
              }else {
                treeData.push({ id: itemId, name: ouList[k], children: [] });
                itemId++;
              }
              previousOu = ouList[k];
            }
            // Add the group details
            currentItem.children.push({ id: itemId, name: groupData[i].cn + ' (' + dn + ')', data: groupData[i] });
            itemId++;
          }
          commit('LDAP_TREE_DATA', treeData);
        });
      }else {
        commit('LDAP_SELECT_STATUS', selectStatus);
      }
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getCurrentLdapSelection({commit, state}, type) {
    let currentLdapGroupsSelected = [];
    let currentLdapUsersSelected = [];

    for(let i = 0; i < state.ldapSyncGroupData.length; i++) {
      let group = {
        cn: state.ldapSyncGroupData[i].cn,
        distinguishedName: state.ldapSyncGroupData[i].dn,
        groupUsers: state.ldapSyncGroupData[i].groupUsers,
        member: state.ldapSyncGroupData[i].member,
        objectGUID: state.ldapSyncGroupData[i].guid,
        sAMAccountName: state.ldapSyncGroupData[i].acc
      };
      
      currentLdapGroupsSelected.push(group);
    }
    
    for(let i = 0; i < state.ldapSyncUserData.length; i++) {
      let user = {
        cn: state.ldapSyncUserData[i].cn,
        distinguishedName: state.ldapSyncUserData[i].dn,
        sAMAccountName: state.ldapSyncUserData[i].username,
        memberOf: state.ldapSyncUserData[i].memberOf,
        objectGUID: state.ldapSyncUserData[i].guid,
        givenName: state.ldapSyncUserData[i].givenName,
        sn: state.ldapSyncUserData[i].sn,
        mail: state.ldapSyncUserData[i].mail
      };
      
      currentLdapUsersSelected.push(user);
    }

    let retPayload = {
      'currentLdapGroupsSelected': currentLdapGroupsSelected,
      'currentLdapUsersSelected': currentLdapUsersSelected,
      'type': type
    };

    commit('LDAP_SELECTED_DATA', retPayload);
  },
  saveLdapItems({commit}, payload) {
    let data = {
      'variables': {
        'requestType': { 'value': 'store', 'type': 'String' },
        'action': { 'value': 'save', 'type': 'String' },
        'type': { 'value': payload.type, 'type': 'String' },
        'ldapUsers': { 'value': payload.ldapUsers, 'type': 'Json' },
        'ldapGroups': { 'value': payload.ldapGroups, 'type': 'Json' }
      },
      'withVariablesInReturn': true
    }

    return axios.post(baseURL + '/process-definition/key/ldapController/tenant-id/' + tenantId + '/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      let storeStatus = result.data.variables.storeStatus.value;
      
      commit('LDAP_STORE_STATUS', storeStatus);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getLdapItems({commit}) {
    let data = {
      'variables': {
        'requestType': { 'value': 'store', 'type': 'String' },
        'action': { 'value': 'get', 'type': 'String' }
      },
      'withVariablesInReturn': true
    }

    return axios.post(baseURL + '/process-definition/key/ldapController/tenant-id/' + tenantId + '/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      let getStatus = result.data.variables.getStatus.value;
      let ldapUsers = JSON.parse(JSON.parse(result.data.variables.ldapUsers.value));
      let ldapGroups = JSON.parse(JSON.parse(result.data.variables.ldapGroups.value));

      commit('LDAP_GET_STATUS', getStatus);
      commit('LDAP_SYNC_USER_DATA', ldapUsers);
      commit('LDAP_SYNC_GROUP_DATA', ldapGroups);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  async ldapSyncGroups({state}) {
    // Get all users/groups from LDAP (ldapSelect)
    await this.dispatch('ldapSelect').then( async () => {
      // Get saved users/groups to sync against (getLdapItems)
      await this.dispatch('getLdapItems').then( async () => {
        // Loop through groups
        for(let i = 0; i < state.ldapSyncGroupData.length; i++) {
          let groupId = '';
          // Find match with available groups
          for(let j = 0; j < state.availableLdapGroups.length; j++) {
            if(state.ldapSyncGroupData[i].guid == state.availableLdapGroups[j].objectGUID) {
              // Match found
              let groupData = {
                'ldapSyncGroupData': state.ldapSyncGroupData[i],
                'availableLdapGroups': state.availableLdapGroups[j]
              };

              await this.dispatch('getAllGroups').then( async () => {
                await this.dispatch('ldapAddGroup', groupData).then( retData => {
                  groupId = retData.groupId;
                });
              });

              // Add users to group
              let groupUsers = state.availableLdapGroups[j].groupUsers;
              if(groupUsers) {
                // Loop through group users
                for(let l = 0; l < groupUsers.length; l++) {
                  // Check if user exists in Harlequin
                  let groupUser = groupUsers[l];
                  groupUser.groupId = groupId;

                  await this.dispatch('getAllUsers').then( async () => {
                    await this.dispatch('ldapAddUser', groupUser).then( async retData => {
                      await this.dispatch('getAllGroups').then( async () => {
                        let grpPayload = {
                          'groupId': retData.groupId,
                          'callType': 'assignedTo'
                        };
            
                        await this.dispatch('getUsersInGroup', grpPayload).then( () => {
                          this.dispatch('ldapAddUsersToGroup', retData);
                        });
                      });
                    });
                  });
                }
              }
            }
          }
        }          
      });
    });    
  },
  async ldapAddGroup({rootState}, groupData) {
    let groupExists = false;
    let groupId = '';
    let ldapSyncGroupData = groupData.ldapSyncGroupData;
    let availableLdapGroups = groupData.availableLdapGroups;
    let retData = {};

    // Does current group name exist in Harlequin?
    for(let k = 0; k < rootState.groups.allGroups.length; k++) {
      if(ldapSyncGroupData.cn == rootState.groups.allGroups[k].name) {
        // Group exists
        groupId = rootState.groups.allGroups[k].id;
        groupExists = true;
      }
    }

    if(groupExists) {
      // Check if existing group details do not match LDAP
      if(ldapSyncGroupData.cn != availableLdapGroups.cn) {
        // Update group
        let payload = {
          'id': groupId,
          'name': availableLdapGroups.cn,
          'type': 'Workflow'
        };

        this.dispatch('updateGroup', payload);
      }else {
        // Do nothing
      }

      retData = {
        'groupId': groupId
      }
    }else {
      // Create group
      groupId = availableLdapGroups.cn.replace(/[^A-Z0-9]/ig, "");
      let payload = {
        'id': groupId,
        'name': availableLdapGroups.cn,
        'type': 'Workflow',
        'tenant': tenantId
      };

      await this.dispatch('addGroup', payload).then( () => {
        retData = {
          'groupId': groupId
        }
      });
    }

    return retData;
  },
  async ldapAddUser({rootState}, user) {
    let userId = '';
    let firstName = '';
    let lastName = '';
    let email = '';
    let userExists = false;
    let groupId = user.groupId;
    let retData = {};

    for(let m = 0; m < rootState.users.allUsers.length; m++) {
      let uName = user.sAMAccountName.replace(/[^A-Z0-9]/ig, "");

      if(uName == rootState.users.allUsers[m].id) {
        // User exists
        userId = rootState.users.allUsers[m].id;
        firstName = rootState.users.allUsers[m].firstName;
        lastName = rootState.users.allUsers[m].lastName;
        email = rootState.users.allUsers[m].email;
        userExists = true;
      }
    }

    if(userExists) {
      // Check if existing user details do not match LDAP
      if((user.givenName != firstName) || (user.sn != lastName) || (user.mail != email)) {
        // Update user
        let payload = {
          'firstName': user.givenName,
          'lastName': user.sn,
          'email': user.mail,
          'id': userId
        };

        this.dispatch('editUser', payload);
      }

      retData = {
        'userId': userId,
        'groupId': groupId
      }
    }else {
      // Create user
      userId = user.sAMAccountName.replace(/[^A-Z0-9]/ig, "");

      // Generate random password (will be updated when user logs in)
      let str = '';
      let length = 2;
      let chars = 'abcdefghijklmnopqrstuvwxyz';

      for (let i = 0; i < length; i++) {
          str += chars.charAt(Math.floor(Math.random() * chars.length));
      }

      length = 1;
      chars = '!@$%^&*';

      for (let i = 0; i < length; i++) {
          str += chars.charAt(Math.floor(Math.random() * chars.length));
      }

      length = 1;
      chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

      for (let i = 0; i < length; i++) {
          str += chars.charAt(Math.floor(Math.random() * chars.length));
      }

      length = 1;
      chars = '0123456789';

      for (let i = 0; i < length; i++) {
          str += chars.charAt(Math.floor(Math.random() * chars.length));
      }

      length = 7;
      chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@$%^&*';

      for (let i = 0; i < length; i++) {
          str += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      // End password gen

      let payload = {
        'profile': {
          'id': userId,
          'firstName': user.givenName,
          'lastName': user.sn,
          'email': user.mail
        },
        'credentials': {
          'password': str
        }
      };
      await this.dispatch('addUser', payload).then( async () => {

        let rolePayload = {
          'id': 'userRole',
          'userId': userId
        };
        await this.dispatch('addUserToRole', rolePayload).then( () => {
          retData = {
            'userId': userId,
            'groupId': groupId
          }
        });
      });
    }
    
    return retData;
  },
  async ldapAddUsersToGroup({commit, rootState}, data) {
    let inGroup = false;
    let assignedUsers = rootState.users.assignedUsers;
    
    for(let i = 0; i < assignedUsers.length; i++) {
      if(data.userId == assignedUsers[i].id) {
        inGroup = true;
      }
    }

    if(!inGroup) {
      let usersToAdd = [];
      usersToAdd.push(data.userId);

      let payload = {
        'groupId': data.groupId,
        'users': usersToAdd
      }
      await this.dispatch('addUsersToGroup', payload).then( () => {
        commit('LDAP_GROUP_USERS_ADDED', 'complete');
      });
    }
  },
  async ldapSyncUsers({commit, state}) {
    // Get all users/groups from LDAP (ldapSelect)
    await this.dispatch('ldapSelect').then( async () => {
      // Get saved users/groups to sync against (getLdapItems)
      await this.dispatch('getLdapItems').then( async () => {
        // Loop through users
        for(let i = 0; i < state.ldapSyncUserData.length; i++) {
          // Find match with available users
          for(let j = 0; j < state.availableLdapUsers.length; j++) {
            if(state.ldapSyncUserData[i].guid == state.availableLdapUsers[j].objectGUID) {
              // Match found
              let user = state.availableLdapUsers[j];
              user.groupId = '';

              await this.dispatch('getAllUsers').then( async () => {
                await this.dispatch('ldapAddUser', user).then( retData => {
                  commit('LDAP_USER_ADDED', retData);
                });
              });
            }
          }
        }
      });
    });
  },
  removeLdapUsers({state}, ldapUsersToRemove) {
    // Loop through list of users to remove
    for(let i = 0; i < ldapUsersToRemove.length; i++) {
      let removeUser = true;
      // Loop through sync'ed groups
      for(let j = 0; j < state.ldapSyncGroupData.length; j++) {
        // Check against each groups members
        for(let k = 0; k < state.ldapSyncGroupData[j].groupUsers.length; k++) {
          if(ldapUsersToRemove[i].objectGUID == state.ldapSyncGroupData[j].groupUsers[k].objectGUID) {
            // Found the user in a group, so don't remove them
            removeUser = false;
          }
        }
      }

      if(removeUser) {
        // Remove user from Harlequin
        this.dispatch('deleteUser', ldapUsersToRemove[i].sAMAccountName);
        // Should probably update log with sync data here
      }
    }
  },
  removeLdapGroups({state, rootState}, ldapGroupsToRemove) {
    // Loop through list of groups to remove
    for(let i = 0; i < ldapGroupsToRemove.length; i++) {
      // Loop through group members
      for(let j = 0; j < ldapGroupsToRemove[i].groupUsers.length; j++) {
        let removeUser = true;
        // Check group member against other sync'ed groups
        for(let k = 0; k < state.ldapSyncGroupData.length; k++) {
          // Check against each groups members
          for(let l = 0; l < state.ldapSyncGroupData[k].groupUsers.length; l++) {
            if(ldapGroupsToRemove[i].groupUsers[j].objectGUID == state.ldapSyncGroupData[k].groupUsers[l].objectGUID && 
              state.ldapSyncGroupData[k].cn != ldapGroupsToRemove[i].cn) {
              // Found the user in a group, so don't remove them
              removeUser = false;
            }
          }
        }
        // Check group member against other sync'ed users
        for(let m = 0; m < state.ldapSyncUserData.length; m++) {
          if(ldapGroupsToRemove[i].groupUsers[j].objectGUID == state.ldapSyncUserData[m].guid) {
            // User is sync'ed individually, so don't remove them
            removeUser = false;
          }
        }

        if(removeUser) {
          // Check if user is an admin
          for(let n = 0; n < rootState.users.allUsers.length; n++) {
            if(ldapGroupsToRemove[i].groupUsers[j].sAMAccountName == rootState.users.allUsers[n].id) {
              // If not, mark for removal
              if(rootState.users.allUsers[n].role != 'adminRole') {
                // Remove user from Harlequin
                this.dispatch('deleteUser', ldapGroupsToRemove[i].groupUsers[j].sAMAccountName);
              }else {
                // Do nothing
              }
            }
          }
          // Should probably update log with sync data here
        }

      }

      // Remove group from Harlequin
      let groupId = ldapGroupsToRemove[i].cn.replace(/[^A-Z0-9]/ig, "");
      this.dispatch('deleteGroup', groupId);
      // Should probably update log with sync data here
    }
  },
  removeLdapUserFromGroup({state, rootState}, removeFromGroup) {
    // Loop through list of user to remove from group
    for(let i = 0; i < removeFromGroup.length; i++) {
      let removeUser = true;
      // Check user against other sync'ed groups
      for(let j = 0; j < state.ldapSyncGroupData.length; j++) {
        // Check against each groups members
        for(let k = 0; k < state.ldapSyncGroupData[j].groupUsers.length; k++) {
          if(removeFromGroup[i].objectGUID == state.ldapSyncGroupData[j].groupUsers[k].objectGUID && 
            state.ldapSyncGroupData[j].cn != removeFromGroup[i].groupCn) {
            // Found the user in a group, so don't remove them
            removeUser = false;
          }
        }
      }
      // Check user against other sync'ed users
      for(let l = 0; l < state.ldapSyncUserData.length; l++) {
        if(removeFromGroup[i].objectGUID == state.ldapSyncUserData[l].guid) {
          // User is sync'ed individually, so don't remove them
          removeUser = false;
        }
      }

      if(removeUser) {
        for(let n = 0; n < rootState.users.allUsers.length; n++) {
          if(removeFromGroup[i].sAMAccountName == rootState.users.allUsers[n].id) {
            // If not, mark for removal
            if(rootState.users.allUsers[n].role != 'adminRole') {
              // Remove user from Harlequin
              this.dispatch('deleteUser', removeFromGroup[i].sAMAccountName);
            }else {
              // Do nothing
            }
          }
        }
        // Should probably update log with sync data here
      }else {
        // Just remove user from the group
        let groupId = removeFromGroup[i].groupCn.replace(/[^A-Z0-9]/ig, "");

        let usersToRemove = [];
        usersToRemove.push(removeFromGroup[i].sAMAccountName);

        let payload = {
          'groupId': groupId,
          'users': usersToRemove
        }

        this.dispatch('removeUsersFromGroup', payload);
        // Should probably update log with sync data here
      }
    }
  },
  getAllTemplates({commit}) {
    let data = {
      'variables': {
        'requestType': { 'value': 'get', 'type': 'String' },
        'templateId': { 'value': 0, 'type': 'Integer' }
      },
      'withVariablesInReturn': true
    }
    return axios.post(baseURL + '/process-definition/key/templateController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      let docTemplates = JSON.parse(result.data.variables.docTemplates.value);
      let emailTemplates = JSON.parse(result.data.variables.emailTemplates.value);
      
      commit('DOC_TEMPLATES', docTemplates);
      commit('EMAIL_TEMPLATES', emailTemplates);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getTemplateData({commit}, templateKey) {
    let data = {
      'variables': {
        'requestType': { 'value': 'getData', 'type': 'String' },
        'templateKey': { 'value': templateKey, 'type': 'String' }
      },
      'withVariablesInReturn': true
    }
    return axios.post(baseURL + '/process-definition/key/templateController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      let templateName = result.data.variables.templateName.value;
      let templateData = result.data.variables.templateData.value;
      commit('UPDATE_TEMPLATE_NAME', templateName);
      commit('TEMPLATE_DATA', templateData);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  saveTemplate({commit}, payload) {
    let data = {
      'variables': {
        'requestType': { 'value': 'save', 'type': 'String' },
        'templateId': { 'value': payload.id, 'type': 'Integer' },
        'templateName': { 'value': payload.name, 'type': 'String' },
        'templateKey': { 'value': payload.key, 'type': 'String' },
        'templateType': { 'value': payload.type, 'type': 'String' },
        'templateData': { 'value': payload.data, 'type': 'String' }
      }
    }
    return axios.post(baseURL + '/process-definition/key/templateController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {      
      commit('SAVED_TEMPLATE', 'success');
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  deleteTemplate({commit}, templateId) {
    let data = {
      'variables': {
        'requestType': { 'value': 'delete', 'type': 'String' },
        'templateId': { 'value': templateId, 'type': 'Integer' }
      }
    }
    return axios.post(baseURL + '/process-definition/key/templateController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {      
      commit('DELETED_TEMPLATE', 'success');
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  promoteTemplatesCheck({commit}, payload) {
    let data = {
      'variables': {
        'requestType': { 'value': 'promote', 'type': 'String' },
        'promoteTemplateData': { 'value': payload.promotes, 'type': 'Json' },
        'checkType': { 'value': 'get', 'type': 'String' },
      },
      'withVariablesInReturn': true
    };
    return axios.post(payload.engine + '/engine-rest/process-definition/key/templateController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
      let templateData = JSON.parse(result.data.variables.templateData.value);
      commit('PROMOTE_TEMPLATE_DATA', templateData);
    }).catch(error => {
      if(error != 'TypeError: data is null') {
        let msg = 'API error: ' + error;
        commit('ERROR_MESSAGE', msg);
      }
    });
  },
  promoteTemplates({commit}, payload) {
    let data = {
      'variables': {
        'requestType': { 'value': 'promote', 'type': 'String' },
        'promoteTemplateData': { 'value': payload.promotes, 'type': 'Json' },
        'checkType': { 'value': 'getLocal', 'type': 'String' },
      },
      'withVariablesInReturn': true
    };
    return axios.post(baseURL + '/process-definition/key/templateController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
      let templateData = result.data.variables.templateData.value;
      
      let data = {
        'variables': {
          'requestType': { 'value': 'promote', 'type': 'String' },
          'promoteTemplateData': { 'value': templateData, 'type': 'Json' },
          'checkType': { 'value': 'update', 'type': 'String' },
        },
        'withVariablesInReturn': true
      };
      return axios.post(payload.engine + '/engine-rest/process-definition/key/templateController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {        
        let retData = [];

        if(result.status == 200) {
          retData = JSON.parse(result.data.variables.retData.value);
        }

        commit('PROMOTE_TEMPLATE_RES', retData);
      }).catch(error => {
        if(error != 'TypeError: data is null') {
          let msg = 'API error: ' + error;
          commit('ERROR_MESSAGE', msg);
        }
      });
    }).catch(error => {
      if(error != 'TypeError: data is null') {
        let msg = 'API error: ' + error;
        commit('ERROR_MESSAGE', msg);
      }
    });
  },
  getAllConnections({commit}) {
    let data = {
      'variables': {
        'requestType': { 'value': 'external', 'type': 'String' },
        'action': { 'value': 'getAll', 'type': 'String' }
      },
      'withVariablesInReturn': true
    };
    return axios.post(baseURL + '/process-definition/key/databaseController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      if(typeof result.data.variables !== 'undefined') {
        commit('EXT_DB_CONNECTIONS', JSON.parse(result.data.variables.allExtDbs.value));
      }else {
        commit('EXT_DB_CONNECTIONS', []);
      }
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  addDbConnection({commit}, payload) {
    let data = {
      'variables': {
        'requestType': { 'value': 'external', 'type': 'String' },
        'action': { 'value': 'add', 'type': 'String' },
        'dbConnType': { 'value': payload.dbConnType, 'type': 'String' },
        'dbName': { 'value': payload.dbName, 'type': 'String' },
        'dbIpAddr': { 'value': payload.dbIpAddr, 'type': 'String' },
        'dbPort': { 'value': payload.dbPort, 'type': 'Integer' },
        'dbUser': { 'value': payload.dbUser, 'type': 'String' },
        'dbPass': { 'value': payload.dbPass, 'type': 'String' }
      },
      'withVariablesInReturn': true
    };
    return axios.post(baseURL + '/process-definition/key/databaseController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      if(result.data.variables.connectionTest.value == 'success') {
        commit('DB_CONN_ADDED', 'success');
      }else {
        commit('DB_CONN_ADDED', 'failed');
      }
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  editDbConnection({commit}, payload) {
    let data = {
      'variables': {
        'requestType': { 'value': 'external', 'type': 'String' },
        'action': { 'value': 'edit', 'type': 'String' },
        'dbConnId': { 'value': payload.dbConnId, 'type': 'Integer' },
        'dbConnType': { 'value': payload.dbConnType, 'type': 'String' },
        'dbName': { 'value': payload.dbName, 'type': 'String' },
        'dbIpAddr': { 'value': payload.dbIpAddr, 'type': 'String' },
        'dbPort': { 'value': payload.dbPort, 'type': 'Integer' },
        'dbUser': { 'value': payload.dbUser, 'type': 'String' },
        'dbPass': { 'value': payload.dbPass, 'type': 'String' }
      },
      'withVariablesInReturn': true
    };
    return axios.post(baseURL + '/process-definition/key/databaseController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      if(result.data.variables.connectionTest.value == 'success') {
        commit('DB_CONN_EDITED', 'success');
      }else {
        commit('DB_CONN_EDITED', 'failed');
      }
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  deleteDbConnection({commit}, dbConnId) {
    let data = {
      'variables': {
        'requestType': { 'value': 'external', 'type': 'String' },
        'action': { 'value': 'delete', 'type': 'String' },
        'dbConnId': { 'value': dbConnId, 'type': 'Integer' }
      }
    };
    return axios.post(baseURL + '/process-definition/key/databaseController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {      
      commit('DB_CONN_DELETED', 'success');
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  checkEngine({commit, state}, hqUrl) {
    state.checkEngine = false;
    return axios.get(hqUrl + '/engine-rest/engine', {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      if(result.status == 200) {
        commit('CHECK_ENGINE', true);
      }else {
        commit('CHECK_ENGINE', false);
      }
    }).catch( () => {
      commit('CHECK_ENGINE', false);
    });
  },
  getAllHqConnections({commit}) {
    let data = {
      'variables': {
        'requestType': { 'value': 'engines', 'type': 'String' },
        'action': { 'value': 'getAll', 'type': 'String' }
      },
      'withVariablesInReturn': true
    };
    return axios.post(baseURL + '/process-definition/key/databaseController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      if(typeof result.data.variables.allHqConns !== 'undefined') {
        commit('HQ_CONNECTIONS', JSON.parse(result.data.variables.allHqConns.value));
      }else {
        commit('HQ_CONNECTIONS', []);
      }
      
      if(typeof result.data.variables.tenantInfo !== 'undefined') {
        commit('TENANT_INFO', JSON.parse(result.data.variables.tenantInfo.value));
      }else {
        commit('TENANT_INFO', []);
      }
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  async addHqConnection({commit, state}, payload) {
    await this.dispatch('checkEngine', payload.hqUrl).then( () => {
      if(state.checkEngine) {
        let data = {
          'variables': {
            'requestType': { 'value': 'engines', 'type': 'String' },
            'action': { 'value': 'add', 'type': 'String' },
            'hqUrl': { 'value': payload.hqUrl, 'type': 'String' },
            'hqName': { 'value': payload.hqName, 'type': 'String' }
          },
          'withVariablesInReturn': true
        };
        return axios.post(baseURL + '/process-definition/key/databaseController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
          let tenantData = {
            'hqUrl': payload.hqUrl,
            'hqConnId': result.data.variables.hqConnId.value
          };
          this.dispatch('addRemoteTenants', tenantData);
          commit('HQ_CONN_ADDED', 'success');
        }).catch(error => {
          throw new Error(`API ${error}`);
        });
      }
    });
  },
  async editHqConnection({commit, state}, payload) {
    await this.dispatch('checkEngine', payload.hqUrl).then( () => {
      if(state.checkEngine) {
        let data = {
          'variables': {
            'requestType': { 'value': 'engines', 'type': 'String' },
            'action': { 'value': 'edit', 'type': 'String' },
            'hqConnId': { 'value': payload.hqConnId, 'type': 'Integer' },
            'hqUrl': { 'value': payload.hqUrl, 'type': 'String' },
            'hqName': { 'value': payload.hqName, 'type': 'String' }
          }
        };
        return axios.post(baseURL + '/process-definition/key/databaseController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {      
          let tenantData = {
            'hqUrl': payload.hqUrl,
            'hqConnId': payload.hqConnId
          };
          this.dispatch('addRemoteTenants', tenantData);
          commit('HQ_CONN_EDITED', 'success');
        }).catch(error => {
          throw new Error(`API ${error}`);
        });
      }
    });
  },
  deleteHqConnection({commit}, hqConnId) {
    let data = {
      'variables': {
        'requestType': { 'value': 'engines', 'type': 'String' },
        'action': { 'value': 'delete', 'type': 'String' },
        'hqConnId': { 'value': hqConnId, 'type': 'Integer' }
      }
    };
    return axios.post(baseURL + '/process-definition/key/databaseController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {      
      commit('HQ_CONN_DELETED', 'success');
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  addRemoteTenants({commit, state}, payload) {
    state.tenantsAdded = false;
    return axios.get(payload.hqUrl + '/engine-rest/tenant', {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( result => {     
      // Filter out portals
      let tenants = [];
      for(let i = 0; i < result.data.length; i++) {
        if(result.data[i].id != 'portal') {
          tenants.push(result.data[i]);
        }
      } 

      let data = {
        'variables': {
          'requestType': { 'value': 'tenants', 'type': 'String' },
          'action': { 'value': 'add', 'type': 'String' },
          'engineId': { 'value': payload.hqConnId, 'type': 'Integer' },
          'tenants': { 'value': JSON.stringify(tenants), 'type': 'Json' }
        }
      };
      return axios.post(baseURL + '/process-definition/key/databaseController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {      
        commit('TENANTS_ADDED', true);
      }).catch(error => {
        throw new Error(`API ${error}`);
      });
    }).catch( () => {
      commit('TENANTS_ADDED', false);
    });
  },
  getAllRemoteTenants({commit}) {
    let data = {
      'variables': {
        'requestType': { 'value': 'tenants', 'type': 'String' },
        'action': { 'value': 'getAll', 'type': 'String' }
      },
      'withVariablesInReturn': true
    };
    return axios.post(baseURL + '/process-definition/key/databaseController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      if(typeof result.data.variables !== 'undefined') {
        commit('REMOTE_TENANTS', JSON.parse(result.data.variables.remoteTenants.value));
      }else {
        commit('REMOTE_TENANTS', []);
      }
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  refreshRemoteTenants({state}) {
    let data = {
      'variables': {
        'requestType': { 'value': 'tenants', 'type': 'String' },
        'action': { 'value': 'deleteAll', 'type': 'String' }
      }
    };
    return axios.post(baseURL + '/process-definition/key/databaseController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {      
      this.dispatch('getAllHqConnections').then( () => {
        for(let i = 0; i < state.allHqConns.length; i++) {
          let tenantData = {
            'hqUrl': state.allHqConns[i].URL,
            'hqConnId': state.allHqConns[i].ID
          };
          this.dispatch('addRemoteTenants', tenantData);
        }
      });
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getAllApis({commit}) {
    let data = {
      'variables': {
        'requestType': { 'value': 'apiVault', 'type': 'String' },
        'action': { 'value': 'getAll', 'type': 'String' }
      },
      'withVariablesInReturn': true
    };
    return axios.post(baseURL + '/process-definition/key/databaseController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      if(typeof result.data.variables !== 'undefined') {
        commit('ALL_APIS', JSON.parse(result.data.variables.allApis.value));
      }else {
        commit('ALL_APIS', []);
      }
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  addApi({commit}, payload) {
    let data = {
      'variables': {
        'requestType': { 'value': 'apiVault', 'type': 'String' },
        'action': { 'value': 'add', 'type': 'String' },
        'name': { 'value': payload.name, 'type': 'String' },
        'authType': { 'value': payload.authType, 'type': 'String' },
        'basicUser': { 'value': payload.basicUser, 'type': 'String' },
        'basicPass': { 'value': payload.basicPass, 'type': 'String' },
        'apiKey': { 'value': payload.apiKey, 'type': 'String' },
        'apiValue': { 'value': payload.apiValue, 'type': 'String' },
        'grantType': { 'value': payload.grantType, 'type': 'String' },
        'clientId': { 'value': payload.clientId, 'type': 'String' },
        'clientSecret': { 'value': payload.clientSecret, 'type': 'String' },
        'endpoint': { 'value': payload.endpoint, 'type': 'String' },
        'headers': { 'value': payload.headers, 'type': 'String' }
      }
    };
    return axios.post(baseURL + '/process-definition/key/databaseController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      if(result.status == 200) {
        commit('API_ADDED', true);
      }else {
        commit('API_ADDED', false);
      }
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  editApi({commit}, payload) {
    let data = {
      'variables': {
        'requestType': { 'value': 'apiVault', 'type': 'String' },
        'action': { 'value': 'edit', 'type': 'String' },
        'id': { 'value': payload.id, 'type': 'Integer' },
        'name': { 'value': payload.name, 'type': 'String' },
        'authType': { 'value': payload.authType, 'type': 'String' },
        'basicUser': { 'value': payload.basicUser, 'type': 'String' },
        'basicPass': { 'value': payload.basicPass, 'type': 'String' },
        'apiKey': { 'value': payload.apiKey, 'type': 'String' },
        'apiValue': { 'value': payload.apiValue, 'type': 'String' },
        'grantType': { 'value': payload.grantType, 'type': 'String' },
        'clientId': { 'value': payload.clientId, 'type': 'String' },
        'clientSecret': { 'value': payload.clientSecret, 'type': 'String' },
        'endpoint': { 'value': payload.endpoint, 'type': 'String' },
        'headers': { 'value': payload.headers, 'type': 'String' }
      }
    };
    return axios.post(baseURL + '/process-definition/key/databaseController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      if(result.status == 200) {
        commit('API_UPDATED', true);
      }else {
        commit('API_UPDATED', false);
      }
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  deleteApi({commit}, apiId) {
    let data = {
      'variables': {
        'requestType': { 'value': 'apiVault', 'type': 'String' },
        'action': { 'value': 'delete', 'type': 'String' },
        'id': { 'value': apiId, 'type': 'Integer' }
      },
      'withVariablesInReturn': true
    };
    return axios.post(baseURL + '/process-definition/key/databaseController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      if(result.status == 200) {
        commit('API_DELETED', true);
      }else {
        commit('API_DELETED', false);
      }
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  updateOpLog({commit}, payload) {
    let logData = {
      'variables': {
        'requestType': { 'value': 'opLog', 'type': 'String' },
        'action': { 'value': 'update', 'type': 'String' },
        'category': { 'value': payload.category, 'type': 'String' },
        'userId': { 'value': payload.userId, 'type': 'String' },
        'caseId': { 'value': payload.caseId, 'type': 'Integer' },
        'processName': { 'value': payload.processName, 'type': 'String' },
        'taskName': { 'value': payload.taskName, 'type': 'String' },
        'operation': { 'value': payload.operation, 'type': 'String' },
        'msg': { 'value': payload.msg, 'type': 'String' },
        'dateTime': { 'value': payload.dateTime, 'type': 'String' }
      }
    };
    return axios.post(baseURL + '/process-definition/key/databaseController/start', logData, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {
      commit('OP_LOG_UPDATED', 'success');
    }).catch(error => {
      let msg = 'Failed to write to Operation Log. ' + error;
      commit('OP_LOG_ERROR_MSG', msg);
    });
  },
  updateExternalOpLog({commit, state}, payload) {
    if(!state.enablePentestMode) {
      let logData = {
        'variables': {
          'requestType': { 'value': 'opLog', 'type': 'String' },
          'action': { 'value': 'update', 'type': 'String' },
          'category': { 'value': payload.category, 'type': 'String' },
          'userId': { 'value': payload.userId, 'type': 'String' },
          'caseId': { 'value': payload.caseId, 'type': 'Integer' },
          'processName': { 'value': payload.processName, 'type': 'String' },
          'taskName': { 'value': payload.taskName, 'type': 'String' },
          'operation': { 'value': payload.operation, 'type': 'String' },
          'msg': { 'value': payload.msg, 'type': 'String' },
          'dateTime': { 'value': payload.dateTime, 'type': 'String' }
        }
      };
      return axios.post(baseURL + '/process-definition/key/databaseController/start', logData, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( () => {
        commit('OP_LOG_UPDATED', 'success');
      }).catch(error => {
        let msg = 'Failed to write to Operation Log. ' + error;
        commit('OP_LOG_ERROR_MSG', msg);
      });
    }
  },
  getOpLog({commit}, payload) {
    let logData = {
      'variables': {
        'requestType': { 'value': 'opLog', 'type': 'String' },
        'action': { 'value': 'get', 'type': 'String' },
        'dateFrom': { 'value': payload.dateFrom, 'type': 'String' },
        'dateTo': { 'value': payload.dateTo, 'type': 'String' }
      },
      'withVariablesInReturn': true
    };
    return axios.post(baseURL + '/process-definition/key/databaseController/start', logData, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
      if(typeof result.data.variables !== 'undefined') {
        commit('OP_LOG', JSON.parse(result.data.variables.opLog.value));
      }else {
        commit('OP_LOG', []);
      }
    }).catch(error => {
      let msg = 'Failed to get Operation Log. ' + error;
      commit('OP_LOG_ERROR_MSG', msg);
    });
  },
  getErrorLog({commit}, action) {
    let logData = {
      'variables': {
        'requestType': { 'value': 'errorLog', 'type': 'String' },
        'action': { 'value': action, 'type': 'String' }
      },
      'withVariablesInReturn': true
    };
    return axios.post(baseURL + '/process-definition/key/databaseController/start', logData, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
      if(typeof result.data.variables.errorLog !== 'undefined') {
        commit('ERROR_LOG', JSON.parse(result.data.variables.errorLog.value));
      }else {
        commit('ERROR_LOG', []);
      }
    }).catch(error => {
      let msg = 'Failed to get Error Log. ' + error;
      commit('ERROR_LOG_ERROR_MSG', msg);
    });
  },
  sendSupportRequest({commit}, payload) {
    let data = {
      'variables': {
        'requestType': { 'value': 'send', 'type': 'String' },
        'from': { 'value': payload.from, 'type': 'String' },
        'to': { 'value': payload.to, 'type': 'String' },
        'body': { 'value': payload.body, 'type': 'String' }
      }
    };

    if(payload.fileData) {
      data.variables['fileData'] = { 'value': payload.fileData, 'type': 'File', 'valueInfo': { 'filename': payload.fileName, 'mimetype': payload.mimeType, 'encoding': 'UTF-8' } };
      data.variables['fileName'] = { 'value': payload.fileName, 'type': 'String' };
      data.variables['withAttachment'] = { 'value': true, 'type': 'Boolean' };
    }else {
      data.variables['withAttachment'] = { 'value': false, 'type': 'Boolean' };
    }

    return axios.post(baseURL + '/process-definition/key/supportController/tenant-id/harlequin/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {
      commit('SUPPORT_REQUEST', true);
    }).catch( () => {
      commit('SUPPORT_REQUEST', false);
    });
  },
  supportSettings({commit}, payload) {
    let data = {
      'variables': {
        'requestType': { 'value': 'settings', 'type': 'String' },
        'action': { 'value': payload.action, 'type': 'String' }
      },
      'withVariablesInReturn': true
    }

    if(payload.action == 'set') {
      data.variables['supportEmail'] = { 'value': payload.supportEmail, 'type': 'String' };
    }

    return axios.post(baseURL + '/process-definition/key/supportController/tenant-id/harlequin/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
      if(payload.action == 'get') {
        commit('SUPPORT_EMAIL', result.data.variables.supportEmail.value);
      }
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  createLookupKey({commit}, payload) {
    let data = {
      'variables': {
        'keyLookup': { 'value': true, 'type': 'Boolean' },
        'createUser': { 'value': false, 'type': 'Boolean' },
        'updateUserCreds': { 'value': false, 'type': 'Boolean' },
        'action': { 'value': 'set', 'type': 'String' },
        'userId': { 'value': payload, 'type': 'String' },
        'baseUrl': { 'value': window.location.href, 'type': 'String' }
      },
      'withVariablesInReturn': true
    }
    return axios.post(baseURL + '/process-definition/key/userController/tenant-id/harlequin/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( result => {      
      let success = result.data.variables.success.value;

      commit('RESET_KEY_CREATED', success);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getLookupKey({commit}, payload) {
    let data = {
      'variables': {
        'keyLookup': { 'value': true, 'type': 'Boolean' },
        'createUser': { 'value': false, 'type': 'Boolean' },
        'updateUserCreds': { 'value': false, 'type': 'Boolean' },
        'action': { 'value': 'get', 'type': 'String' },
        'key': { 'value': payload, 'type': 'String' }
      },
      'withVariablesInReturn': true
    }
    return axios.post(baseURL + '/process-definition/key/userController/tenant-id/harlequin/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( result => {      
      let uid = result.data.variables.uid.value;

      commit('RESET_UID', uid);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  removeLookupKey({commit}, payload) {
    let data = {
      'variables': {
        'keyLookup': { 'value': true, 'type': 'Boolean' },
        'createUser': { 'value': false, 'type': 'Boolean' },
        'updateUserCreds': { 'value': false, 'type': 'Boolean' },
        'action': { 'value': 'remove', 'type': 'String' },
        'key': { 'value': payload, 'type': 'String' }
      },
      'withVariablesInReturn': true
    }
    return axios.post(baseURL + '/process-definition/key/userController/tenant-id/harlequin/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( result => {      
      let success = result.data.variables.success.value;

      commit('RESET_KEY_REMOVED', success);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  }
};

const mutations = {
  ALL_TENANTS(state, payload) {
    state.allTenants = payload;
  },
  STORAGE_DETAILS(state, payload) {
    state.storageDetails = payload;
  },
  SAVED_STORAGE_DETAILS(state, payload) {
    state.savedStorageDetails = payload;
  },
  SERVER_DETAILS(state, payload) {
    state.serverDetails = payload;
  },
  SAVED_SERVER_DETAILS(state, payload) {
    state.savedServerDetails = payload;
  },
  SSO_DETAILS(state, payload) {
    state.ssoDetails = payload;
  },
  SAVED_SSO_DETAILS(state, payload) {
    state.savedSsoDetails = payload;
  },
  SAML_METADATA(state, payload) {
    state.samlMetadata = payload;
  },
  LDAP_USER_DATA(state, payload) {
    state.availableLdapUsers = payload;
  },
  LDAP_GROUP_DATA(state, payload) {
    state.availableLdapGroups = payload;
  },
  LDAP_TREE_DATA(state, payload) {
    state.availableLdapTree = payload;
  },
  LDAP_STORE_STATUS(state, payload) {
    state.ldapStoreStatus = payload;
  },
  LDAP_GET_STATUS(state, payload) {
    state.ldapGetStatus = payload;
  },
  LDAP_SELECT_STATUS(state, payload) {
    state.ldapSelectStatus = payload;
  },
  LDAP_SYNC_USER_DATA(state, payload) {
    state.ldapSyncUserData = payload;
  },
  LDAP_SYNC_GROUP_DATA(state, payload) {
    state.ldapSyncGroupData = payload;
  },
  LDAP_SELECTED_DATA(state, payload) {
    state.ldapSelectedData = payload;
  },
  LDAP_GROUP_USER_ADDED(state, payload) {
    state.ldapGroupUserAdded = payload;
  },
  LDAP_USER_ADDED(state, payload) {
    state.ldapUserAdded = payload;
  },
  LDAP_GROUP_USERS_ADDED(state, payload) {
    state.ldapGroupUsersAdded = payload;
  },
  SAVED_TEMPLATE(state, payload) {
    state.savedTemplate = payload;
  },
  UPDATE_TEMPLATE_ID(state, payload) {
    state.templateId = payload;
  },
  UPDATE_TEMPLATE_NAME(state, payload) {
    state.templateName = payload;
  },
  UPDATE_TEMPLATE_KEY(state, payload) {
    state.templateKey = payload;
  },
  UPDATE_TEMPLATE_TYPE(state, payload) {
    state.templateType = payload;
  },
  UPDATE_TEMPLATE_ACTION(state, payload) {
    state.templateAction = payload;
  },
  UPDATE_LAST_TAB(state, payload) {
    state.lastTab = payload;
  },
  TEMPLATE_DATA(state, payload) {
    state.templateData = payload;
  },
  DOC_TEMPLATES(state, payload) {
    state.allDocTemplates = payload;
  },
  EMAIL_TEMPLATES(state, payload) {
    state.allEmailTemplates = payload;
  },
  DELETED_TEMPLATE(state, payload) {
    state.deletedTemplate = payload;
  },
  EXT_DB_CONNECTIONS(state, payload) {
    state.allExtDbs = payload;
  },
  DB_CONN_ADDED(state, payload) {
    state.dbConnAdded = payload;
  },
  DB_CONN_EDITED(state, payload) {
    state.dbConnEdited = payload;
  },
  DB_CONN_DELETED(state, payload) {
    state.dbConnDeleted = payload;
  },
  CHECK_ENGINE(state, payload) {
    state.checkEngine = payload;
  },
  HQ_CONNECTIONS(state, payload) {
    state.allHqConns = payload;
  },
  TENANT_INFO(state, payload) {
    state.tenantInfo = payload;
  },
  HQ_CONN_ADDED(state, payload) {
    state.hqConnAdded = payload;
  },
  HQ_CONN_EDITED(state, payload) {
    state.hqConnEdited = payload;
  },
  HQ_CONN_DELETED(state, payload) {
    state.hqConnDeleted = payload;
  },
  TENANTS_ADDED(state, payload) {
    state.tenantsAdded = payload;
  },
  REMOTE_TENANTS(state, payload) {
    state.remoteTenants = payload;
  },
  ALL_APIS(state, payload) {
    state.allApis = payload;
  },
  API_ADDED(state, payload) {
    state.apiAdded = payload;
  },
  API_UPDATED(state, payload) {
    state.apiUpdated = payload;
  },
  API_DELETED(state, payload) {
    state.apiDeleted = payload;
  },
  OP_LOG(state, payload) {
    state.operationLog = payload;
  },
  OP_LOG_UPDATED(state, payload) {
    state.operationLogUpdated = payload;
  },
  OP_LOG_ERROR_MSG(state, payload) {
    state.operationLogError = payload;
  },
  ERROR_LOG(state, payload) {
    state.errorLog = payload;
  },
  ERROR_LOG_ERROR_MSG(state, payload) {
    state.errorLogError = payload;
  },
  PROMOTE_TEMPLATE_DATA(state, payload) {
    state.promoteTemplateData = payload;
  },
  PROMOTE_TEMPLATE_RES(state, payload) {
    state.promoteTemplateRes = payload;
  },
  LICENSE_START_DATE(state, payload) {
    state.licenseStartDate = payload;
  },
  LICENSE_EXPIRY_DATE(state, payload) {
    state.licenseExpiryDate = payload;
  },
  LICENSE_KEY_UPDATED(state, payload) {
    state.licenseKeyUpdated = payload;
  },
  ENABLE_PROCESS_UNDEPLOY(state, payload) {
    state.enableProcessUndeploy = payload;
  },
  ENABLE_PROCESS_DELETION(state, payload) {
    state.enableProcessDeletion = payload;
  },
  ENABLE_PENTEST_MODE(state, payload) {
    state.enablePentestMode = payload;
  },
  SUPPORT_REQUEST(state, payload) {
    state.supportRequest = payload;
  },
  SUPPORT_EMAIL(state, payload) {
    state.supportEmail = payload;
  },
  RESET_KEY_CREATED(state, payload) {
    state.resetKeyCreated = payload;
  },
  RESET_KEY_REMOVED(state, payload) {
    state.resetKeyRemoved = payload;
  },
  RESET_UID(state, payload) {
    state.resetUid = payload;
  },
};

export default {
  state,
  getters,
  actions,
  mutations
}